import { useHotKeys } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import WeaverService from 'Services/WeaverService'
import { setCount, setEdits, setSelection, setSelectionType, setTotalRowCount } from '../SpreadSheetDataProvider/actions'
import { emptyCell, selectionTypes } from '../helpers'

export default CellSelectShortcuts = ->

  [{
    columns,
    count,
    edits,
    selection
  }, dispatch] = useSpreadSheetData()

  useHotKeys([{
    sequence: ['down', 'enter']
    fn: ->
      next = selection[1] + 1
      dispatch(setCount(next + 30)) if next >= count
      dispatch(setSelection([selection[0], next]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'up'
    fn: ->
      if selection[1] > 0
        dispatch(setSelection([selection[0], selection[1] - 1]))
      else
        dispatch(setSelection(selection[0]))
        dispatch(setSelectionType(selectionTypes.COL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'left'
    fn: ->
      if selection[0] > 0
        dispatch(setSelection([selection[0] - 1, selection[1]]))
      else
        dispatch(setSelection(selection[1]))
        dispatch(setSelectionType(selectionTypes.ROW))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: ['right', 'tab']
    fn: ->
      dispatch(setSelection([selection[0] + 1, selection[1]]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+left'
    fn: ->
      if selection[0] > 0
        dispatch(setSelection([selection, [selection[0] - 1, selection[1]]]))
        dispatch(setSelectionType(selectionTypes.MULTI_CELL))
      else
        dispatch(setSelection(selection[1]))
        dispatch(setSelectionType(selectionTypes.ROW))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+right'
    fn: ->
      dispatch(setSelection([selection, [selection[0] + 1, selection[1]]]))
      dispatch(setSelectionType(selectionTypes.MULTI_CELL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+up'
    fn: ->
      if selection[1] > 0
        dispatch(setSelection([selection, [selection[0], selection[1] - 1]]))
        dispatch(setSelectionType(selectionTypes.MULTI_CELL))
      else
        dispatch(setSelection(selection[0]))
        dispatch(setSelectionType(selectionTypes.COL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+down'
    fn: ->
      dispatch(setSelection([selection, [selection[0], selection[1] + 1]]))
      dispatch(setSelectionType(selectionTypes.MULTI_CELL))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'backspace'
    fn: ->
      dispatch(setEdits({
        prevEdits: edits
        nextEdits: {
          edits...,
          [selection[1]]: {
            edits[selection[1]]...,
            [selection[0]]: emptyCell(columns[selection[0]])
          }
        }
      }))
    temporary: true
    expr: WeaverService.userCanEdit()
    watchers: [selection, edits]
  }])

  <div />





